<template>
    <span class="route-label" @click="$emit('click')">
        <span v-if="route && type">
            <b>{{ type }}</b>
            <span v-if="mapping">: {{ mapping }}</span>
        </span>
        <b v-else>
            <i>{{ $t('[Service not selected]') }}</i>
        </b>
    </span>
</template>

<script>
    export default {
        name: 'RouteLabel',
        props: {
            route: {
                type: Object,
                default: () => null,
            },
        },
        emits: ['click'],
        computed: {
            mapping() {
                switch (this.route.type) {
                    case 1:
                        return this.route.numbers.join(', ');
                    case 2:
                        if (this.route.number === '') {
                            return this.$t('Pass through access number as outbound number');
                        }
                        return this.route.number;
                    case 3: {
                        const script = this.$store.routeData.scripts.find((x) => x.scriptId === this.route.scriptId);
                        return script ? script.name : this.$t('Unknown');
                    }
                    case 4:
                        switch (this.route.mappingType) {
                            case 1: {
                                const user = this.$store.routeData.users.find((x) => x.userId === this.route.mappingId);
                                return user
                                    ? `${user.firstName} ${user.lastName} (${user.username})`
                                    : this.$t('Unknown');
                            }
                            case 2: {
                                const treatment = this.$store.routeData.treatments.find(
                                    (x) => x.treatmentId === this.route.mappingId,
                                );
                                return treatment ? treatment.name : this.$t('Unknown');
                            }
                        }
                        break;
                    case 5: {
                        const voicemail = this.$store.routeData.voicemailProfiles.find(
                            (x) => x.mailboxId === this.route.mailboxId,
                        );
                        return voicemail ? voicemail.name : this.$t('Unknown');
                    }
                    case 6: {
                        const list = this.$store.routeData.mediaLists.find(
                            (x) => x.mediaListId === this.route.mappingType,
                        );
                        const prompt = list ? list.prompts.find((x) => x.id === this.route.mappingId) : null;
                        return prompt ? prompt.name : this.$t('Unknown');
                    }
                    case 7: {
                        const profile = this.$store.routeData.splitProfiles.find(
                            (x) => x.scriptId === this.route.scriptId,
                        );
                        return profile ? profile.name : this.$t('Unknown');
                    }
                }

                return null;
            },
            type() {
                switch (this.route.type) {
                    case 1:
                        return (this.route.record ? this.$t('RECORDED') : '[x]').replace(
                            /\[x]/g,
                            this.$t('ONWARD_ROUTE'),
                        );
                    case 2: {
                        const trunk = this.$store.routeData.trunks.find((x) => x.trunkId === this.route.trunkId);
                        const trunkName = trunk ? trunk.name : this.$t('Unknown');
                        return (this.route.record ? this.$t('RECORDED') : '[x]').replace(
                            /\[x]/g,
                            `${this.$t('SIP_TRUNK')} - ${trunkName}`,
                        );
                    }
                    case 3:
                        return this.$t('IVR_SERVICE');
                    case 4:
                        switch (this.route.mappingType) {
                            case 1:
                                return this.$t('User');
                            case 2:
                                return this.$t('Call Treatment');
                            case 3:
                                return this.$t('PBX Voicemail Retrieval');
                        }

                        return this.$t('Unknown Type');
                    case 5:
                        return this.$t(this.route.mappingType === 1 ? 'Voicemail Deposit' : 'Voicemail Retrieval');
                    case 6:
                        return this.$t('Play Prompt');
                    case 7:
                        return this.$t('PERCENTAGE_SPLIT');
                }

                return null;
            },
        },
    };
</script>
